import React, { useRef, useState } from "react";
import FloatingMenu from "./FloatingMenu";

type IconPopoverDropdownProps = {
  title: string;
  iconClass: string;
  btnClassName?: string;
  menuWidth?: number;
  children: (api: { close: () => void }) => React.ReactNode;
  isActive?: boolean;
  value?: string;
};

export default function IconPopoverDropdown({
  title,
  iconClass,
  btnClassName = "btn btn-link",
  menuWidth = 320,
  children,
  value
}: IconPopoverDropdownProps) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement>(null);

  const close = () => setOpen(false);

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        className={btnClassName}
        title={`${title} ${value ? ": " + value : ""}`}
        onClick={() => setOpen((v) => !v)}
      >
        <i className={iconClass} />
      </button>

      <FloatingMenu anchorRef={btnRef} open={open} onClose={close}>
        <div
          className="dropdown-menu show p-3 shadow-sm"
          style={{ position: "static", width: menuWidth }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="small text-muted mb-2">{title}</div>
          {children({ close })}
        </div>
      </FloatingMenu>
    </>
  );
}
